export const botQuestions = [
  { type: "text", text: "Write your first and last name?" },

  {
    type: "multi",
    stepId: "verif",
    parts: [
      { type: "text", text: "Please specify the path for your verification." },
      {
        type: "options",
        text: "Please select one:",
        options: ["Number", "Telegram", "Email"],
      },
    ],
  },
  { type: "text", text: "" },

  { type: "text", text: "Enter the verification code" },

  { type: "text", text: "Okay! Now type your email please" },

  {
    type: "multi",
    stepId: "platform",
    parts: [
      {
        type: "text",
        text: "Which platform would you prefer for future communication?",
      },
      {
        type: "options",
        text: "Please select one:",
        options: ["WhatsApp", "Telegram", "Email"],
      },
    ],
  },

  {
    type: "options",
    text: "",
    options: ["Mentioned", "New"],
  },

  { type: "text", text: "" },

  { type: "text", text: "What’s your company name?" },

  {
    type: "options",
    text: "Will you use your own phone numbers or ours?",
    options: ["Use your own", "Use ours"],
  },
  {
    type: "upload",
    stepId: "docs",
    text: "Drag file here or",
    buttonText: "select file with numbersoad",
    showIcon: true,
  },
  {
    type: "text",
    text: "Our team will contact you to clarify information on the numbers.",
  },

  { type: "text", text: "Thanks! We’ll contact you soon." },
];

export const botVariant = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0 },
};

export const userVariant = {
  hidden: { opacity: 0, y: 14 },
  visible: { opacity: 1, y: 0 },
};

const fitsWidth = (el) => el && el.scrollWidth <= el.clientWidth;

export const applyOneLineWidthLimit = (nextValue, el, prevValue, setValue) => {
  const clean = nextValue.replace(/[\r\n]+/g, "");
  setValue(clean);

  requestAnimationFrame(() => {
    if (!el) return;
    if (!fitsWidth(el)) {
      setValue(prevValue);
      requestAnimationFrame(() => {
        try {
          el.selectionStart = el.selectionEnd = prevValue.length;
        } catch (_) {}
      });
    }
  });
};

export const getVerificationQuestion = (method) => {
  if (method === "Telegram")
    return "Please send your phone number or nickname in Telegram";
  if (method === "Number") return "Please type your phone number";
  return "Please type your email";
};

export const getCommunicationQuestion = (platform) => {
  if (platform === "Telegram")
    return "What is your phone number or nickname for contact on Telegram?";
  if (platform === "WhatsApp") return "What is your WhatsApp phone number?";
  return "Please type your email";
};

export const getPlatformKey = (platform) => {
  if (platform === "Telegram") return "telegram";
  if (platform === "WhatsApp") return "whatsapp";
  return "email";
};

export const validateByStep = (
  text,
  stepIndex,
  { verificationMethod, communicationPlatform },
) => {
  const value = String(text ?? "")
    .trim()
    .replace(/\s+/g, " ");

  if (stepIndex === 0) {
    const nameRegex = /^[A-Za-zА-Яа-яЁё\s-]+$/;
    if (!nameRegex.test(value)) return "Letters only.";
    if (value.split(" ").filter(Boolean).length < 2)
      return "First and last name.";
    if (value.replace(/[\s-]/g, "").length < 5) return "Min. 5 letters.";
  }

  if (stepIndex === 2) {
    if (!verificationMethod) return "Choose verification method first.";

    if (verificationMethod === "Telegram") {
      const telegramUser = /^@?[a-zA-Z0-9_]{5,32}$/;
      const allowedPhone = /^[0-9+\-\s]+$/;
      const digitsOnly = value.replace(/\D/g, "");

      const looksLikeUser = telegramUser.test(value);
      const looksLikePhone =
        allowedPhone.test(value) &&
        digitsOnly.length >= 7 &&
        digitsOnly.length <= 14;

      if (!looksLikeUser && !looksLikePhone)
        return "Enter Telegram @username or phone number.";
    }

    if (verificationMethod === "Number") {
      const allowed = /^[0-9+\-\s]+$/;
      if (!allowed.test(value)) return "Only digits, space, + and -.";
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length < 7) return "Min. 7 digits.";
      if (digitsOnly.length > 14) return "Max. 14 digits.";
    }

    if (verificationMethod === "Email") {
      const email = value.toLowerCase();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRegex.test(email)) return "Invalid email.";
    }
  }

  if (stepIndex === 3) {
    const digitsOnly = value.replace(/\D/g, "");
    if (digitsOnly.length < 4) return "Min. 4 digits.";
    if (digitsOnly.length > 8) return "Max. 8 digits.";
    if (!/^\d+$/.test(digitsOnly)) return "Digits only.";
  }

  if (stepIndex === 4) {
    const email = value.toLowerCase();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!emailRegex.test(email)) return "Invalid email.";
    if (email.length > 120) return "Email is too long.";
  }

  if (stepIndex === 7) {
    if (!communicationPlatform) return "Choose communication platform first.";

    if (communicationPlatform === "Telegram") {
      const telegramUser = /^@?[a-zA-Z0-9_]{5,32}$/;
      const allowedPhone = /^[0-9+\-\s]+$/;
      const digitsOnly = value.replace(/\D/g, "");

      const looksLikeUser = telegramUser.test(value);
      const looksLikePhone =
        allowedPhone.test(value) &&
        digitsOnly.length >= 7 &&
        digitsOnly.length <= 14;

      if (!looksLikeUser && !looksLikePhone)
        return "Enter Telegram @username or phone number.";
    }

    if (communicationPlatform === "WhatsApp") {
      const allowed = /^[0-9+\-\s]+$/;
      if (!allowed.test(value)) return "Only digits, space, + and -.";
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length < 7) return "Min. 7 digits.";
      if (digitsOnly.length > 14) return "Max. 14 digits.";
    }

    if (communicationPlatform === "Email") {
      const email = value.toLowerCase();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRegex.test(email)) return "Invalid email.";
    }
  }
  if (stepIndex === 8) {
    if (value.length < 2) return "Company name is too short.";
    if (value.length > 80) return "Company name is too long.";
  }

  return "";
};
